import React from 'react'

function Hat() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <g fill="currentColor">
                <path d="M2 4a1.833 1.833 0 001.833 1.834h4c.087 0 .171.033.234.093a.78.78 0 00.573.24h.333a.333.333 0 01.334.333v1.727a.333.333 0 01-.294.333A8.107 8.107 0 002.42 14a.32.32 0 00.033.28.333.333 0 00.24.16c2.434.285 4.883.415 7.334.387 2.45.028 4.9-.102 7.333-.387a.333.333 0 00.24-.16.32.32 0 00.033-.28 8.106 8.106 0 00-6.62-5.446.333.333 0 01-.293-.334V6.5a.333.333 0 01.333-.333h.28a.84.84 0 00.34-.073.333.333 0 01.327.04c1.1.833 2.907 2.033 4.153 2.033a1.833 1.833 0 100-3.667H12.02a.34.34 0 01-.267-.126 2.226 2.226 0 00-3.38-.18.333.333 0 01-.446 0c-1.054-.807-2.834-2.027-4.094-2.027A1.833 1.833 0 002 4zM17.96 15.707a.314.314 0 00-.127-.227.327.327 0 00-.246-.067 57.336 57.336 0 01-7.587.42 57.336 57.336 0 01-7.587-.42.325.325 0 00-.246.067.314.314 0 00-.127.227c0 .12 0 .24-.04.36a1.173 1.173 0 00.913 1.226c2.338.418 4.713.599 7.087.54a35.338 35.338 0 007.087-.54A1.174 1.174 0 0018 16.067c0-.12 0-.24-.04-.36z"></path>
            </g>
        </svg>
    )
}

export default Hat
